import { productService } from '../services/firebaseService';

// Function to create all BioEdge products
async function createAllProducts() {
  try {
    console.log('🌱 Creating all BioEdge products...');
    const result = await productService.createAllBioEdgeProducts();
    
    if (result.success) {
      console.log(`✅ Successfully created ${result.created} products!`);
      console.log('📋 Created products:');
      result.products.forEach(product => {
        console.log(`  - ${product.name} (R${product.price})`);
      });
      return result;
    } else {
      console.error('❌ Failed to create products:', result.error);
      return result;
    }
  } catch (error) {
    console.error('❌ Error:', error);
    return { success: false, error: error.message };
  }
}

// Function to check existing products
async function checkProducts() {
  try {
    console.log('🔍 Checking existing products...');
    const products = await productService.getAllProducts();
    
    console.log(`📊 Found ${products.length} products in Firebase:`);
    products.forEach(product => {
      console.log(`  - ${product.name} (R${product.price}) - ID: ${product.id}`);
    });
    
    return products;
  } catch (error) {
    console.error('❌ Error checking products:', error);
    return [];
  }
}

// Function to clear all products
async function clearAllProducts() {
  try {
    console.log('🗑️ Clearing all products...');
    const products = await productService.getAllProducts();
    
    let deletedCount = 0;
    for (const product of products) {
      try {
        await productService.deleteProduct(product.id);
        console.log(`✅ Deleted: ${product.name}`);
        deletedCount++;
      } catch (error) {
        console.error(`❌ Failed to delete ${product.name}:`, error.message);
      }
    }
    
    console.log(`🎉 Cleared ${deletedCount} products!`);
    return { success: true, deleted: deletedCount };
  } catch (error) {
    console.error('❌ Error clearing products:', error);
    return { success: false, error: error.message };
  }
}

// Function to test Firebase connection and get detailed error info
async function testFirebaseConnection() {
  try {
    console.log('🔥 Testing Firebase connection...');
    
    // Test getting all products
    const products = await productService.getAllProducts();
    console.log(`✅ Firebase connection successful! Found ${products.length} products`);
    
    // Test getting a specific product if any exist
    if (products.length > 0) {
      const firstProduct = products[0];
      console.log(`🔍 Testing getProduct with ID: ${firstProduct.id}`);
      const singleProduct = await productService.getProduct(firstProduct.id);
      console.log(`✅ Successfully retrieved product: ${singleProduct.name}`);
    }
    
    return { success: true, products: products };
  } catch (error) {
    console.error('❌ Firebase connection failed:', error);
    console.error('Error details:', {
      message: error.message,
      code: error.code,
      stack: error.stack
    });
    return { success: false, error: error.message };
  }
}

// Make functions available globally for console access
if (typeof window !== 'undefined') {
  window.createAllProducts = createAllProducts;
  window.checkProducts = checkProducts;
  window.clearAllProducts = clearAllProducts;
  window.testFirebaseConnection = testFirebaseConnection;
}

// Export for module usage
export {
  createAllProducts,
  checkProducts,
  clearAllProducts,
  testFirebaseConnection
}; 